webpackJsonp([9],{

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(23);



var URL_PREFIX = '';
var winPageData = {
  header: {
    logo: "//dev58.myzaker.com/zkres.myzaker.com/webres/pVue/cms_rongmeiti/index/dist/./static/img/logo.png",
    title: "舆情监控-新型冠状肺炎",
    right_text: "2020年3月02日 星期一"
  },
  screen_init: {
    "list": [{
      "target": "t_1",
      "url": "http://rongmeiti.dev58.myzaker.com/chart_format?title=pie-2_line&type=pie-2,line"
    }, {
      "target": "t_2",
      "url": "http://rongmeiti.dev58.myzaker.com/chart_format?title=list_line&type=list,pie-1"
    }, {
      "target": "t_3",
      "url": "http://rongmeiti.dev58.myzaker.com/chart_data?type=relate"
    }, {
      "target": "t_4",
      "url": "http://rongmeiti.dev58.myzaker.com/chart_format?title=carsoul&type=carsoul,list,video"
    }, {
      "target": "t_5",
      "url": "http://rongmeiti.dev58.myzaker.com/chart_data?type=cloud"
    }, {
      "target": "t_6",
      "url": "http://rongmeiti.dev58.myzaker.com/chart_data?type=pie-1"
    }, {
      "target": "t_7",
      "url": "http://rongmeiti.dev58.myzaker.com/chart_data?type=bar"
    }, {
      "target": "t_8",
      "url": "http://rongmeiti.dev58.myzaker.com/chart_data?type=bar"
    }]
  }
};

if (false) {
  window.WinPageData = _Object$assign({}, winPageData, common);
}

/* unused harmony default export */ var _unused_webpack_default_export = (winPageData);

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_axios_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_pages_js__ = __webpack_require__(27);





var AXIOS_INIT = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      winPageData: window.WinPageData
    };
  },
  created: function created() {
    if (!AXIOS_INIT) {
      __WEBPACK_IMPORTED_MODULE_2__config_axios_js__["a" /* default */].call(this);
      AXIOS_INIT = true;
    }
  },

  computed: {
    isDevEnv: function isDevEnv() {
      return "production" == 'development';
    }
  },
  methods: {
    goPage: function goPage(name) {
      var queryObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var isOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var _queryObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, queryObj);
      var hashObj = null;
      if (_queryObj.hash) {
        hashObj = _queryObj.hash;
        delete _queryObj.hash;
      }
      var url = __WEBPACK_IMPORTED_MODULE_3__config_pages_js__["a" /* pages */].getUrl(name, _queryObj);
      if (hashObj) {
        var hashStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index_js__["a" /* queryStringify */])(hashObj).replace('&', '#');
        url += hashStr;
      }
      if (isOpen) {
        window.open(url);
      } else {
        window.location.href = url;
      }
    },
    goHashPage: function goHashPage(name) {
      var queryObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var isOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var url = __WEBPACK_IMPORTED_MODULE_3__config_pages_js__["a" /* pages */].getUrl(name, queryObj);
      if (isOpen) {
        window.open(url);
      } else {
        window.location.href = url;
      }
    }
  }
});

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var BASE_URL = "//dev58.myzaker.com/mlab.myzaker.com/";

/* unused harmony default export */ var _unused_webpack_default_export = ({
  common_api: {
    login_api: "http://account.dev58.myzaker.com/auth/login",
    login_page: "http://rongmeiti.dev58.myzaker.com/auth/login",
    loginout_api: "http://rongmeiti.dev58.myzaker.com/auth/logout",
    myorg_page: "http://rongmeiti.dev58.myzaker.com/home",
    system_authlogin: "http://rongmeiti.dev58.myzaker.com/system_authlogin",
    yuqing_eventlist: "http://rongmeiti.dev58.myzaker.com/yuqing_eventlist",

    org_user_list_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/user/list",
    org_user_role_list_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/user/role/list",
    org_user_add_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/user/add",
    org_user_edit_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/user/edit",
    org_children_tree: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/children/tree",

    auth_password_reset_page: "http://rongmeiti-saas.dev58.myzaker.com/auth/password/reset",

    org_sync_list_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/sync/user/list",
    org_retry_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/sync/user/retry",

    login_by_mobile_api: "http://account.dev58.myzaker.com/auth/login/mobile",
    register_api: "http://account.dev58.myzaker.com/auth/register",
    register_check_mobile_api: "http://account.dev58.myzaker.com/auth/register/exists/mobile",
    register_check_complete_api: "http://account.dev58.myzaker.com/auth/register/complete/check",

    login_register: "http://account.dev58.myzaker.com/auth/link_to_login",

    login_captcha_api: "http://account.dev58.myzaker.com/auth/captcha",

    captcha_mobile_api: "http://account.dev58.myzaker.com/auth/captcha/mobile"
  },
  user_info: {
    nickname: "demo",
    uid: 9052
  },
  login_page: "/login.html",
  login_api: "/auth/login",
  loginout_api: "/auth/logout",
  myorg_page: "/home",
  index_page: "/",
  register_page: "/register.html",
  apps: [{
    id: 1,
    name: "xxx",
    api_url_logout: "https://www.baidu.com"
  }],
  referer: "/auth/login?111111"
});

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

var host = location.host == '' ? '' : location.protocol+'//'+location.host;
var path_res = location.host == '' ? './' : host+"/pc/index/";

const config = {
  API_URL: (location.hostname == 'localhost')? 'http://rongmeiti.dev58.myzaker.com' : location.protocol+'//'+location.host,
  APP_UA: 'ZKRMT', //UA识别 ZKRMT/1.0 ； 以前的com.dio.rmt  
  APP_KEY: 'Tgj8FxWIT4RWhhcq',
  APP_AKEY: 'Bearer',
  HOST: host, //http://xx.xxx.com
  HOST_RES: path_res //http://xx.xxx.com/xxx/
}
module.exports = config


/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_view_design__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_view_design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_view_design__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);







var axiosConfig = function axiosConfig() {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, config, {
            transformRequest: [function (data) {
                data = __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(data);
                return data;
            }]
        });
    });
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
        var res = response.data;
        if (!res) {
            __WEBPACK_IMPORTED_MODULE_2_view_design__["Message"].destroy();
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_2_view_design__["Message"].error('出了点问题，请稍后重试');
            }, 10);
            return;
        }
        if (res.stat == -1) {
            window.location.href = res.data.url;
        } else if (res.stat == 0) {
            __WEBPACK_IMPORTED_MODULE_2_view_design__["Message"].destroy();
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_2_view_design__["Message"].error(res.msg || '请求失败');
            }, 10);
        }
        return res;
    }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2_view_design__["Message"].destroy();
        setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_2_view_design__["Message"].error('出了点问题，请稍后重试');
        }, 10);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
};

/* harmony default export */ __webpack_exports__["a"] = (axiosConfig);

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);


var DEV_58 = 'http://dev58.myzaker.com/mlab.myzaker.com/?model=';
var PROD = 'http://mlab.myzaker.com/?model=';

var pages = {
    dev: {
        index: './index.html',
        home: './home.html',
        admin: './admin.html'
    },
    dev58: {
        home: DEV_58 + 'home',
        admin: DEV_58 + 'admin'
    },
    prod: {
        home: PROD + 'home',
        admin: PROD + 'admin'
    },
    getUrl: function getUrl(name, queryObj) {
        var isEncode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var url = void 0;
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* queryStringify */])(queryObj, isEncode);
        if (false) {
            url = pages.dev[name] + '?' + query;
        } else if (location.href.indexOf('121.9.213.58') != -1 || location.href.indexOf('http://dev58.myzaker.com') != -1) {
            url = pages.dev58[name] + query;
        } else {
            url = pages.prod[name] + query;
        }
        return url;
    }
};

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(771)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(829),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_view_design__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_view_design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_view_design__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_view_design_dist_styles_iview_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_view_design_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_view_design_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_index_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apm__ = __webpack_require__(7);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_view_design___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_apm__["a" /* default */]);
window.winVue = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({ el: '#root', template: '<App/>', components: { App: __WEBPACK_IMPORTED_MODULE_5__pages_index_vue___default.a } });

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mock_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_r_login__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_r_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_r_login__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { rLogin: __WEBPACK_IMPORTED_MODULE_3__components_r_login___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  data: function data() {
    return {
      picPath: {
        b1: "//zkres.myzaker.com/static/rmt/b1.png",
        b2: "//zkres.myzaker.com/static/rmt/b2.png",
        b3: "//zkres.myzaker.com/static/rmt/b3.png",
        b4: "//zkres.myzaker.com/static/rmt/b4.png",
        live_icon: "//zkres.myzaker.com/static/rmt/live_icon.png",
        live: "//zkres.myzaker.com/static/rmt/live.png",
        live5: "//zkres.myzaker.com/static/rmt/live5.png",
        c1: "//zkres.myzaker.com/static/rmt/c1.png",
        c2: "//zkres.myzaker.com/static/rmt/c2.png",
        hsm_icon: "//zkres.myzaker.com/static/rmt/hsm_icon.png",
        hsm: "//zkres.myzaker.com/static/rmt/hsm.png",
        c3: "//zkres.myzaker.com/static/rmt/c3.png",
        c4: "//zkres.myzaker.com/static/rmt/c4.png",
        ai_icon: "//zkres.myzaker.com/static/rmt/ai_icon.png",
        ai: "//zkres.myzaker.com/static/rmt/ai.png",
        c5: "//zkres.myzaker.com/static/rmt/c5.png",
        c6: "//zkres.myzaker.com/static/rmt/c6.png",
        vr_icon: "//zkres.myzaker.com/static/rmt/vr_icon.png",
        vr: "//zkres.myzaker.com/static/rmt/vr.png",
        c7: "//zkres.myzaker.com/static/rmt/c7.png",
        c8: "//zkres.myzaker.com/static/rmt/c8.png",
        h5_icon: "//zkres.myzaker.com/static/rmt/h5_icon.png",
        h5: "//zkres.myzaker.com/static/rmt/h5.png",
        c9: "//zkres.myzaker.com/static/rmt/c9.png",
        c10: "//zkres.myzaker.com/static/rmt/c10.png",
        c11: "//zkres.myzaker.com/static/rmt/c11.png",
        c12: "//zkres.myzaker.com/static/rmt/c12.png",
        c13: "//zkres.myzaker.com/static/rmt/c13.png",
        design_icon: "//zkres.myzaker.com/static/rmt/design_icon.png",
        design: "//zkres.myzaker.com/static/rmt/design.png",
        tab12: "//zkres.myzaker.com/static/rmt/tab12.png",
        nrss: "//zkres.myzaker.com/static/rmt/nrss.png",
        tab61: "//zkres.myzaker.com/static/rmt/tab61.png",
        tab62: "//zkres.myzaker.com/static/rmt/tab62.png",
        tab63: "//zkres.myzaker.com/static/rmt/tab63.png",
        tab64: "//zkres.myzaker.com/static/rmt/tab64.png",
        tab65: "//zkres.myzaker.com/static/rmt/tab65.png",
        tab66: "//zkres.myzaker.com/static/rmt/tab66.png",
        tab4: "//zkres.myzaker.com/static/rmt/tab4.png",
        tab51: "//zkres.myzaker.com/static/rmt/tab51.png",
        tab52: "//zkres.myzaker.com/static/rmt/tab52.png",
        tab53: "//zkres.myzaker.com/static/rmt/tab53.png",
        tab54: "//zkres.myzaker.com/static/rmt/tab54.png",
        tab31: "//zkres.myzaker.com/static/rmt/tab31.png",
        tab32: "//zkres.myzaker.com/static/rmt/tab32.png",
        tab15: "//zkres.myzaker.com/static/rmt/tab15.png",
        tab131: "//zkres.myzaker.com/static/rmt/tab131.png",
        tab132: "//zkres.myzaker.com/static/rmt/tab132.png",
        tab102: "//zkres.myzaker.com/static/rmt/tab102.png",
        tab103: "//zkres.myzaker.com/static/rmt/tab103.png",
        tab101: "//zkres.myzaker.com/static/rmt/tab101.png",
        tab104: "//zkres.myzaker.com/static/rmt/tab104.png",
        tab111: "//zkres.myzaker.com/static/rmt/tab111.png",
        tab113: "//zkres.myzaker.com/static/rmt/tab113.png",
        tab112: "//zkres.myzaker.com/static/rmt/tab112.png",
        tab114: "//zkres.myzaker.com/static/rmt/tab114.png",
        c14: "//zkres.myzaker.com/static/rmt/c14.png",
        tab9: "//zkres.myzaker.com/static/rmt/tab9.png",
        tab7: "//zkres.myzaker.com/static/rmt/tab7.png",
        tab81: "//zkres.myzaker.com/static/rmt/tab81.png",
        tab82: "//zkres.myzaker.com/static/rmt/tab82.png",
        tab141: "//zkres.myzaker.com/static/rmt/tab141.png",
        tab142: "//zkres.myzaker.com/static/rmt/tab142.png",
        tab143: "//zkres.myzaker.com/static/rmt/tab143.png",
        tab144: "//zkres.myzaker.com/static/rmt/tab144.png",
        tab145: "//zkres.myzaker.com/static/rmt/tab145.png",
        tab146: "//zkres.myzaker.com/static/rmt/tab146.png",
        tab147: "//zkres.myzaker.com/static/rmt/tab147.png",
        cooper: {
          pic1: "//zkres.myzaker.com/static/rmt/m1.png",
          pic2: "//zkres.myzaker.com/static/rmt/m2.png",
          pic3: "//zkres.myzaker.com/static/rmt/m3.png",
          pic4: "//zkres.myzaker.com/static/rmt/m4.png",
          pic5: "//zkres.myzaker.com/static/rmt/m5.png",
          pic6: "//zkres.myzaker.com/static/rmt/m6.png",
          pic7: "//zkres.myzaker.com/static/rmt/m7.png",
          pic8: "//zkres.myzaker.com/static/rmt/m8.png",
          pic9: "//zkres.myzaker.com/static/rmt/m9.png",
          pic10: "//zkres.myzaker.com/static/rmt/m10.png",
          pic11: "//zkres.myzaker.com/static/rmt/m11.png",
          pic12: "//zkres.myzaker.com/static/rmt/m12.png",
          pic13: "//zkres.myzaker.com/static/rmt/m13.png",
          pic14: "//zkres.myzaker.com/static/rmt/m14.png",
          pic15: "//zkres.myzaker.com/static/rmt/m15.png",
          pic16: "//zkres.myzaker.com/static/rmt/m16.png",
          pic17: "//zkres.myzaker.com/static/rmt/m17.png",
          pic18: "//zkres.myzaker.com/static/rmt/m18.png",
          pic19: "//zkres.myzaker.com/static/rmt/m19.png",
          pic20: "//zkres.myzaker.com/static/rmt/m20.png",
          pic21: "//zkres.myzaker.com/static/rmt/m21.png",
          pic22: "//zkres.myzaker.com/static/rmt/m22.png",
          pic23: "//zkres.myzaker.com/static/rmt/m23.png",
          pic24: "//zkres.myzaker.com/static/rmt/m24.png"
        },
        banner: WinResourcesDirectory + __webpack_require__(798)
      },
      isScroll: false,
      isClickScroll: false,
      scrollRate: 7,
      secCur: null,
      timer: null,
      openTimer: false
    };
  },

  computed: {},
  mounted: function mounted() {
    this.scrollEvent();
    this.initFixedNavBar();
    this.bindEvent();
  },

  methods: {
    initFixedNavBar: function initFixedNavBar() {
      var $barHtml = $('.nav-list').clone(true);
      $('.fixed-nav').append($barHtml);
    },
    scrollEvent: function scrollEvent() {
      var top = $('.fixed-nav-wrap').height();
      var scrolltop = $(window).scrollTop();
      this.navShowLogic(top, scrolltop);
      if (scrolltop > top) {
        $('.fixed-nav-wrap').show();
      } else {
        $('.fixed-nav-wrap').hide();
      }
    },
    navShowLogic: function navShowLogic(top, scrolltop) {
      var _this = this;

      if (this.openTimer) return;
      clearTimeout(this.timer);
      var $thirdBlock = $('[data-third]');
      var $secBlock = $('[data-sec]');
      var firstBlockOffset = 100;
      var showThirdCur = null;
      $thirdBlock.each(function (index) {
        var theshold = $(this).offset().top - top;
        if (index === 0) theshold = theshold - firstBlockOffset;
        if (theshold <= scrolltop + 10) {
          showThirdCur = $(this).attr('data-third') - 0;
        }
      });
      var secLen = $secBlock.length;
      var thirdLen = $thirdBlock.length;
      var $subNavWrap = $('.sub-nav-wrap');
      var $subNavList = $('.sub-nav-list');

      if ($thirdBlock.eq(thirdLen - 1).offset().top - top + $thirdBlock.eq(thirdLen - 1).height() < scrolltop) {
        showThirdCur = null;
      }

      $secBlock.each(function (index, item) {
        var theshold = $(item).offset().top - $('.fixed-nav-wrap').height();
        if (index === 0) theshold = theshold - firstBlockOffset;
        if (theshold <= scrolltop) {
          _this.secCur = $(item).attr('data-sec') - 0;
        }
      });

      if ($secBlock.eq(secLen - 1).offset().top - top + $secBlock.eq(secLen - 1).height() < scrolltop || $secBlock.eq(0).offset().top - firstBlockOffset - $('.fixed-nav-wrap').height() > scrolltop) {
        this.secCur = null;
      }

      if (showThirdCur !== null) {
        $subNavWrap.addClass('show');
      } else {
        $subNavWrap.removeClass('show');
      }

      var clsHandle = function clsHandle() {
        $('.nav-list>a').removeClass('active');
        if (_this.secCur !== null) {
          $('.nav-list>a').eq(_this.secCur).addClass('active');
        }

        if (showThirdCur !== null) {
          $subNavList.find('a').removeClass('active');
          $subNavList.eq(_this.secCur).find('a').eq(showThirdCur).addClass('active');
          $subNavWrap.addClass('show');
        }
      };

      if (this.openTimer) {
        this.timer = setTimeout(function () {
          clsHandle();
        }, 300);
      } else {
        clsHandle();
      }
    },
    bindEvent: function bindEvent() {
      var that = this;

      $('.menu-list>a').on('click', function () {
        var idx = $(this).index();
        var top = 0;
        switch (idx) {
          case 0:
            top = $('.cooper-type').offset().top;
            break;
        }
        if (top) top -= $('.fixed-nav-wrap').height();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* scrollToEle */])({
          el: top,
          scrollRate: that.scrollRate
        });
      });

      $('.nav-list>a').on('click', function () {
        if (that.isScroll) return;
        $('.nav-list>a').removeClass('active');
        $(this).addClass('active');
        var idx = $(this).index();
        if (idx === 0) {
          var $navList = $('.sub-nav-list').eq(idx);
          $navList.find('a').eq(0).trigger('click');
        } else {
          that.openTimer = true;
          that.isScroll = true;
          var top = $("[data-sec='" + idx + "']").offset().top - $('.fixed-nav-wrap').height();
          console.log({
            el: top,
            scrollRate: that.scrollRate
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* scrollToEle */])({
            el: top,
            scrollRate: that.scrollRate,
            finish: function finish() {
              that.isScroll = false;
              that.openTimer = false;
            }
          });
        }
      });

      $('.sub-nav-list>a').on('click', function () {
        if (that.isScroll) return;
        that.openTimer = true;
        $('.sub-nav-list>a').removeClass('active');
        $(this).addClass('active');
        var cls = $(this).attr('data-cls');
        var top = $(".block-wrap." + cls).offset().top;
        top -= $('.fixed-nav-wrap').height();
        that.isScroll = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* scrollToEle */])({
          el: top,
          scrollRate: that.scrollRate,
          finish: function finish() {
            that.isScroll = false;
            that.openTimer = false;
          }
        });
      });

      $('.block-wrap .btn').on('click', function () {
        $('.menu-list>a').eq(0).trigger('click');
      });

      $(window).on('scroll', this.scrollEvent);
    }
  }
});

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fetch_jsonp__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fetch_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fetch_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);





var A_MINUTE = 60000;
var AN_HOUR = 3600000;
var A_DAY = 86400000;

var Apm = function Apm(opts) {
    var _ts = this,
        defOpts = {};
    this.opts = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(defOpts, opts);

    this.config = {
        platform: navigator.userAgent.toLowerCase().match(/iphone|ipod|ipad/ig) ? 'ios' : 'android',
        app: {
            isInApp: _ts.app.isInApp || false,
            o: _ts.app.os || null,
            s: _ts.app.set || null,
            p: _ts.app.product || null,
            v: _ts.app.version || null }
    };
    this.tools = {
        getUrlName: function getUrlName(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r !== null) return unescape(r[2]);
            return null;
        },
        loadJS: function loadJS(url, success) {
            var domScript = document.createElement('script');
            domScript.src = url;
            success = success || function () {};
            if (navigator.userAgent.indexOf("MSIE") > 0) {
                domScript.onreadystatechange = function () {
                    if ('loaded' === this.readyState || 'complete' === this.readyState) {
                        success();
                        this.onload = this.onreadystatechange = null;
                        this.parentNode.removeChild(this);
                    }
                };
            } else {
                domScript.onload = function () {
                    success();
                    this.onload = this.onreadystatechange = null;
                    this.parentNode.removeChild(this);
                };
            }
            document.getElementsByTagName('head')[0].appendChild(domScript);
        },

        returnData: function returnData(data, keyArr) {
            if ((typeof keyArr === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(keyArr)) === "object") {
                try {
                    return eval("data" + "." + keyArr.join("."));
                } catch (e) {
                    return "";
                }
            } else {
                try {
                    return data;
                } catch (e) {
                    return "";
                }
            }
        },

        zkopen_web: function zkopen_web(url, needUserInfo, openType) {
            if (!url) return false;
            needUserInfo = needUserInfo == 'Y' ? 'Y' : 'N';
            var cmd = {
                open_type: openType,
                web_url: url,
                need_user_info: needUserInfo
            };
            var cmdStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cmd);
            var cmdEncodeStr = encodeURIComponent(cmdStr);
            return 'zkopenthirdapp://?_zkcmd=open_type&iphone_cmd_arg=' + cmdEncodeStr + '&androidphone_cmd_arg=' + cmdEncodeStr;
        }
    };
    this.init();
};

Apm.prototype.install = function (Vue) {
    Vue.prototype.$apm = this;
    Vue.apm = this;
};

Apm.prototype.init = function () {
    var _ts = this;

    window.WinObserver = {
        add: function add(callback, opt) {
            this.subscribers[this.subscribers.length] = {
                callback: callback,
                opt: opt !== 'undefined' ? opt : {}
            };
        },

        remove: function remove(callback) {
            for (var i = 0; i < this.subscribers.length; i++) {
                if (this.subscribers[i].callback === callback) {
                    delete this.subscribers[i];
                }
            }
        },

        publish: function publish(what, _observer) {
            var data = {};
            for (var i = 0; i < this.subscribers.length; i++) {
                if (this.subscribers[i] && typeof this.subscribers[i].callback === 'function') {
                    var observer = _observer !== 'undefined' ? _observer : {};
                    var key = observer.type + '_' + what.type;

                    data[key] = this.subscribers[i].callback({ param: what, opt: this.subscribers[i].opt, observer: observer });
                }
            }
            return data;
        },

        make: function make(o) {
            for (var i in this) {
                o[i] = this[i];
                o.subscribers = [];
            }
        }
    };

    window.WinSubscribe = {
        WINBDClient: function WINBDClient(data) {
            return this.publish(data, { type: 'WINBDClient' });
        }
    };

    window.WinObserver.make(window.WinSubscribe);

    window.WINBDClient = function (param) {
        var data = window.WinSubscribe.WINBDClient(param);
        var key = 'WINBDClient_' + param.type;
        var _data = data[key] ? data[key] : { stat: 0, data: {} };
        return _data;
    };
};

Apm.prototype.app = function () {
    var ua = navigator.userAgent,
        opt = {};
    var reg = ua.match(/aipai\/(.*)\/(.*)\/(.*)\/v\((.*)\)/);
    if (reg) {
        opt.isInApp = reg[0];
        opt.os = reg[1];
        opt.set = reg[2];
        opt.product = reg[3];
        opt.version = reg[4];
    } else {
        opt.isInApp = false;
    }

    opt.is = function (arg) {
        if (reg) {
            return (typeof arg.o !== 'undefined' ? arg.o === opt.os : true) && (typeof arg.p !== 'undefined' ? arg.p === opt.product : true) && (typeof arg.s !== 'undefined' ? arg.s === opt.set : true) && (typeof arg.v !== 'undefined' ? opt.version >= arg.v : true);
        } else {
            return false;
        }
    };
    return opt;
}();

Apm.prototype.globalEvent = {
    handlerTraker: {},

    add: function add(evt, callback) {
        var _ts = this;
        if (!callback) {
            {
                console.error("[vue-render] missing callback arg in globalEvent.addEventListener.");
            }
            return;
        }
        var handlers = _ts.handlerTraker[evt];
        if (!handlers) {
            handlers = _ts.handlerTraker[evt] = [];
        }
        var len = handlers.length;
        for (var i = 0; i < len; i++) {
            if (handlers[i] === callback) {
                return;
            }
        }
        handlers.push(callback);
        document.addEventListener(evt, callback);
    },

    remove: function remove(evt) {
        var _ts = this,
            handlers = _ts.handlerTraker[evt];
        if (!handlers) {
            return;
        }
        handlers.forEach(function (cb) {
            return document.removeEventListener(evt, cb);
        });
        delete _ts.handlerTraker[evt];
    }
};

Apm.prototype.appClient = function (param) {
    try {
        var reg = new RegExp(__WEBPACK_IMPORTED_MODULE_3_config__["APP_UA"], 'ig');
        if (navigator.userAgent.match(reg)) {
            var _param = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                type: '',
                data: {}
            }, param);
            if (typeof _param.data.cbParam == 'undefined') {
                _param.data.cbParam = {};
            }
            if (typeof _param.data.cbName == 'undefined') {
                _param.data.cbName = '';
            }
            _param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_param);
            var data = null;
            console.log(_param);
            if (!navigator.userAgent.match(/iphone|ipod/ig)) {
                data = window.BDClient.call(_param);
            } else {
                data = window.prompt(_param);
            }
            var _data = typeof data == 'string' ? JSON.parse(data) : data;
            return _data;
        } else {
            return {
                stat: 0,
                msg: '不在客户端内'
            };
        }
    } catch (err) {
        return {
            stat: 0,
            msg: '协议执行失败'
        };
    }
};

Apm.prototype.getHasFlagData = function (sign_arg, data) {
    if (!sign_arg) {
        return data;
    }
    var _time = String(Date.parse(new Date()) / 1000),
        sign_args = sign_arg.split('|'),
        prefix = sign_args[0],
        sign_argStr = sign_args[1],
        sign_argArr = sign_argStr.split(','),
        baseParams = this.getBaseParams(),
        allParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(baseParams, data, { _time: _time }),
        _flag = __WEBPACK_IMPORTED_MODULE_3_config__["APP_KEY"] + prefix;
    sign_argArr.map(function (key) {
        _flag += allParams[key];
    });
    _flag += allParams['_time'];

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data, {
        _flag: this.md5(this.md5(_flag).toLowerCase()).toLowerCase(),
        _time: allParams['_time']
    });
};

Apm.prototype.getBaseParams = function () {
    var reg = new RegExp(__WEBPACK_IMPORTED_MODULE_3_config__["APP_UA"], 'ig');
    var baseParams = {
        _app_id: '',
        _version: '',
        _v: '',
        _brand: '',
        _systype: navigator.userAgent.match(/iphone|ipod/ig) ? 'iphone' : 'androidphone',
        _platform: '',
        _udid: '',
        _uid: '',
        _utoken: '',
        _uauthCode: ''
    };
    var pageData = {};
    var cbData = this.appClient({
        type: 'getBaseInfo',
        data: {}
    });
    if (cbData.stat == 1) {
        pageData = cbData.data;
    }
    if (!pageData._uid) {
        var paramArr = window.location.search.substr(1).split('&');
        for (var i = 0; i < paramArr.length; i++) {
            if (paramArr[i].match(/(.+?)=(.+?)/ig)) {
                var curArr = paramArr[i].split('=');
                pageData[curArr[0]] = decodeURIComponent(curArr[1]);
            }
        }
    }


    baseParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(baseParams, {
        _app_id: pageData._app_id || '',
        _version: pageData._version || '',
        _v: pageData._v || '',
        _systype: pageData._systype || '',
        _brand: pageData._brand || '',
        _udid: pageData._udid || '',
        _uid: pageData._uid || '',
        _utoken: pageData._utoken || '',
        _platform: pageData._platform || ''
    });
    return baseParams;
};

Apm.prototype.appIsBridge = function (type) {};

Apm.prototype.appBridge = function (type, _data) {
    var data = _data || null,
        iframe = document.createElement('IFRAME');
    iframe.setAttribute('src', 'lieyou-vw://' + type + '/' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)));
    document.documentElement.appendChild(iframe);
    iframe.parentNode.removeChild(iframe);
    iframe = null;
};

Apm.prototype.refresh = function (type) {};

Apm.prototype.pageData = function () {
    var pageData = {};
    var paramArr = window.location.search.substr(1).split('&');
    for (var i = 0; i < paramArr.length; i++) {
        if (paramArr[i].match(/(.+?)=(.+?)/ig)) {
            var curArr = paramArr[i].split('=');
            pageData[curArr[0]] = decodeURIComponent(curArr[1]);
        }
    }
    return pageData;
}();

Apm.prototype.appStart = function (data) {};

Apm.prototype.wxShare = function (opt) {
    var shareTitle = opt.title || document.title;
    var shareDesc = opt.desc || '';
    var shareLink = opt.link || location.href;
    var sharePic = opt.imgUrl || 'https://zkres.myzaker.com/data/ads_web/share_pic.png';
    var shareTimelineDesc = opt.lineDesc || opt.desc || '';
    window.zk_get_share_info = function () {
        var zk_web_wxshare_param = {
            shareTitle: shareTitle,
            shareDesc: shareDesc,
            shareLink: shareLink,
            sharePic: sharePic,
            shareTimelineDesc: shareTimelineDesc
        };
        var arr = {
            type: "zk_web_wxshare_param",
            result: zk_web_wxshare_param
        };
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr);
    };

    var sharesuccessFunc = function sharesuccessFunc() {
        if (opt.sucFun && typeof opt.sucFun == 'function') {
            opt.sucFun();
        }
    };
    var sharecancelFunc = function sharecancelFunc() {};
    var scriptdom = document.createElement("script");
    scriptdom.type = "text/javascript";
    scriptdom.src = "https://huodong.myzaker.com/wx/wechat_js_api_new.php?v=1";
    document.body.appendChild(scriptdom);
    scriptdom.onload = function () {
        wxShareNew.init(shareTitle, shareDesc, shareTimelineDesc, shareLink, sharePic, sharesuccessFunc, sharecancelFunc);
    };
};

Apm.prototype.initScrollTop = function () {
    var st = null,
        _scTop = document.createElement('span');
    _scTop.setAttribute('class', 'g_scrollTop hidden');
    _scTop.setAttribute('id', 'g_scrollTop');

    document.body.appendChild(_scTop);
    var _el = document.getElementById('g_scrollTop');
    window.addEventListener('scroll', function (event) {
        clearTimeout(st);
        st = setTimeout(function () {
            if (document.body.scrollTop > window.innerHeight) {
                _el.style.display = 'block';
                _el.addEventListener('click', function (event) {
                    _el.style.display = 'none';
                    event.preventDefault();
                    window.scrollTo(0, 0);
                });
            } else {
                _el.style.display = 'none';
            }
        }, 50);
    });
    _el.addEventListener('touchstart', function (event) {
        _el.classList.add('cur');
    });
    _el.addEventListener('touchend', function (event) {
        _el.classList.remove('cur');
    });
};

Apm.prototype.fetch = function (_opt) {
    var _ts = this,
        pageData = _ts.pageData,
        param = "",
        opt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
        method: "GET",
        type: "json",
        cookies: true,
        timeout: 10000,
        param: null,
        paramType: 0,
        headers: {},
        base: true
    }, _opt);
    var baseParams = this.getBaseParams();
    if (opt.base) {
        opt.param = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, baseParams, opt.param);
    }

    opt.param = this.getHasFlagData(opt.sign_arg, opt.param);

    if (baseParams._uauthCode) {
        opt.headers = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, { 'Authorization': __WEBPACK_IMPORTED_MODULE_3_config__["APP_AKEY"] + ' ' + baseParams._uauthCode }, opt.headers);
    }

    console.log('opt.param', opt.param);

    opt.url = opt.url.indexOf('http') >= 0 ? '' + opt.url : '' + __WEBPACK_IMPORTED_MODULE_3_config__["API_URL"] + opt.url;


    if (location.protocol === 'https:') {
        opt.url = opt.url.replace(/^http:(\/\/)/, "$1");
    }
    if (location.protocol === 'http:') {
        opt.url = opt.url.replace(/^https:(\/\/)/, "$1");
    }
    if (opt.param !== null) {
        for (var key in opt.param) {
            if (typeof opt.param[key] !== 'function') {
                param += '&' + key + '=' + encodeURIComponent(opt.param[key]);
            }
        }
        param = param.substring(1);
    }
    if (opt.method.toLowerCase() === "get") {
        if (opt.type === 'jsonp') {
            return __WEBPACK_IMPORTED_MODULE_5_fetch_jsonp___default()(opt.url + (opt.url.indexOf('?') >= 0 ? '&' : '?') + param, {
                timeout: opt.timeout,
                method: opt.method,
                headers: opt.headers,
                credentials: opt.cookies ? 'include' : ''
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                return json;
            }).catch(function (ex) {
                return { error: true, url: ex };
            });
        } else {
            return __WEBPACK_IMPORTED_MODULE_6_axios___default()(opt.url + (opt.url.indexOf('?') >= 0 ? '&' : '?') + param, {
                method: opt.method,
                timeout: opt.timeout,
                withCredentials: opt.cookies,
                headers: opt.headers
            }).then(function (response) {
                return response.data;
            }).catch(function (ex) {
                return { error: true, url: ex };
            });
        }
    } else {
        return __WEBPACK_IMPORTED_MODULE_6_axios___default()(opt.url, {
            method: opt.method,
            timeout: opt.timeout,
            data: opt.paramType == 0 ? param : opt.param,
            withCredentials: opt.cookies,
            headers: opt.headers
        }).then(function (response) {
            return response.data;
        }).catch(function (ex) {
            return { error: true, url: ex };
        });
    }
};

Apm.prototype.molg = function (data) {

    var _ts = this,
        pageData = _ts.pageData,
        _appid = pageData._appid,
        _udid = pageData._udid,
        _uid = pageData._uid,
        _v = pageData._v,
        _version = pageData._version,
        _webcode = pageData._webcode,
        url = '';
    for (var key in data) {
        url += '&' + key + '=' + encodeURIComponent(data[key]);
    }
    if (pageData._uid && pageData._appid && pageData._udid) {
        url += '&_appid=' + _appid + '&_udid=' + _udid + '&_uid=' + _uid + '&_v=' + _v + '&_version=' + _version + '&_webcode=' + _webcode;
    }
    url = url.substring(1);

    new Image().src = '//stat.myzaker.com/stat_h5.php?' + url;
};

Apm.prototype.timeSince = function (dateStr) {
    var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm';

    dateStr = dateStr + '';
    dateStr *= dateStr.length === 10 ? 1000 : 1;
    if (!dateStr) {
        return '';
    }
    var date = new Date(dateStr);
    var recorded = date.valueOf();
    var today = new Date().setHours(0, 0, 0, 0);
    var yesterday = today - A_DAY;
    var theDayBefore = yesterday - A_DAY;
    var now = new Date().valueOf();
    var diffFromRecorded = now - recorded;

    if (diffFromRecorded < A_MINUTE) {
        return '刚刚';
    }

    if (diffFromRecorded < AN_HOUR) {
        return parseInt('' + diffFromRecorded / A_MINUTE) + '分钟前';
    }

    if (diffFromRecorded < now - today) {
        return parseInt('' + diffFromRecorded / AN_HOUR) + '小时前';
    }
    if (diffFromRecorded < now - yesterday) {
        return this.formatTimestamp(dateStr, '昨天 hh:mm');
    }
    if (diffFromRecorded < now - theDayBefore) {
        return this.formatTimestamp(dateStr, '前天 hh:mm');
    }
    return this.formatTimestamp(dateStr, formatStr);
};

Apm.prototype.timeToSec = function (str) {
    if (!str) {
        return 0;
    }
    var arr = str.split(':');
    var sec = 0;
    var length = arr.length - 1;
    for (var i = 0; i <= length; i++) {
        sec = sec + arr[i] * Math.pow(60, length - i);
    }
    return sec;
};

Apm.prototype.formatTimestamp = function (dateStr, str) {
    if (!str) str = 'MM-dd';
    dateStr = dateStr + '';
    dateStr *= dateStr.length === 10 ? 1000 : 1;
    var date = new Date(dateStr);
    var regExArr = ['y+', 'M+', 'd+', 'h+', 'm+', 's+', 'q+', 'S'];
    var resultArr = [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), Math.floor((date.getMonth() + 3) / 3), date.getMilliseconds()];
    for (var i = 0; i < regExArr.length; i++) {
        var pattern = regExArr[i];
        var result = resultArr[i];
        var regEx = new RegExp('(' + pattern + ')');
        if (regEx.test(str)) {
            if (pattern === 'y+') {
                str = str.replace(regEx, result);
            } else {
                var replaceStr = result.toString();

                replaceStr = this.addO(replaceStr);
                str = str.replace(regEx, replaceStr);
            }
        }
    }
    return str;
};

Apm.prototype.addO = function (str) {
    str = str + '';
    if (str.length > 1) {
        return str;
    }
    var temp = '00' + str;
    return temp.substring(str.length);
};

Apm.prototype.md5 = function (value) {
    var hex_chr = "0123456789abcdef",
        rhex = function rhex(num) {
        var str = "";
        for (var j = 0; j <= 3; j++) {
            str += hex_chr.charAt(num >> j * 8 + 4 & 0x0F) + hex_chr.charAt(num >> j * 8 & 0x0F);
        }return str;
    },
        str2blks_MD5 = function str2blks_MD5(str) {
        var nblk = (str.length + 8 >> 6) + 1;
        var blks = new Array(nblk * 16);
        for (var i = 0; i < nblk * 16; i++) {
            blks[i] = 0;
        }for (var i = 0; i < str.length; i++) {
            blks[i >> 2] |= str.charCodeAt(i) << i % 4 * 8;
        }blks[i >> 2] |= 0x80 << i % 4 * 8;
        blks[nblk * 16 - 2] = str.length * 8;
        return blks;
    },
        add = function add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    },
        rol = function rol(num, cnt) {
        return num << cnt | num >>> 32 - cnt;
    },
        cmn = function cmn(q, a, b, x, s, t) {
        return add(rol(add(add(a, q), add(x, t)), s), b);
    },
        ff = function ff(a, b, c, d, x, s, t) {
        return cmn(b & c | ~b & d, a, b, x, s, t);
    },
        gg = function gg(a, b, c, d, x, s, t) {
        return cmn(b & d | c & ~d, a, b, x, s, t);
    },
        hh = function hh(a, b, c, d, x, s, t) {
        return cmn(b ^ c ^ d, a, b, x, s, t);
    },
        ii = function ii(a, b, c, d, x, s, t) {
        return cmn(c ^ (b | ~d), a, b, x, s, t);
    },
        MD5 = function MD5(str) {
        var x = str2blks_MD5(str);
        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;

        for (var i = 0; i < x.length; i += 16) {
            var olda = a;
            var oldb = b;
            var oldc = c;
            var oldd = d;

            a = ff(a, b, c, d, x[i + 0], 7, -680876936);
            d = ff(d, a, b, c, x[i + 1], 12, -389564586);
            c = ff(c, d, a, b, x[i + 2], 17, 606105819);
            b = ff(b, c, d, a, x[i + 3], 22, -1044525330);
            a = ff(a, b, c, d, x[i + 4], 7, -176418897);
            d = ff(d, a, b, c, x[i + 5], 12, 1200080426);
            c = ff(c, d, a, b, x[i + 6], 17, -1473231341);
            b = ff(b, c, d, a, x[i + 7], 22, -45705983);
            a = ff(a, b, c, d, x[i + 8], 7, 1770035416);
            d = ff(d, a, b, c, x[i + 9], 12, -1958414417);
            c = ff(c, d, a, b, x[i + 10], 17, -42063);
            b = ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = ff(a, b, c, d, x[i + 12], 7, 1804603682);
            d = ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = ff(b, c, d, a, x[i + 15], 22, 1236535329);

            a = gg(a, b, c, d, x[i + 1], 5, -165796510);
            d = gg(d, a, b, c, x[i + 6], 9, -1069501632);
            c = gg(c, d, a, b, x[i + 11], 14, 643717713);
            b = gg(b, c, d, a, x[i + 0], 20, -373897302);
            a = gg(a, b, c, d, x[i + 5], 5, -701558691);
            d = gg(d, a, b, c, x[i + 10], 9, 38016083);
            c = gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = gg(b, c, d, a, x[i + 4], 20, -405537848);
            a = gg(a, b, c, d, x[i + 9], 5, 568446438);
            d = gg(d, a, b, c, x[i + 14], 9, -1019803690);
            c = gg(c, d, a, b, x[i + 3], 14, -187363961);
            b = gg(b, c, d, a, x[i + 8], 20, 1163531501);
            a = gg(a, b, c, d, x[i + 13], 5, -1444681467);
            d = gg(d, a, b, c, x[i + 2], 9, -51403784);
            c = gg(c, d, a, b, x[i + 7], 14, 1735328473);
            b = gg(b, c, d, a, x[i + 12], 20, -1926607734);

            a = hh(a, b, c, d, x[i + 5], 4, -378558);
            d = hh(d, a, b, c, x[i + 8], 11, -2022574463);
            c = hh(c, d, a, b, x[i + 11], 16, 1839030562);
            b = hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = hh(a, b, c, d, x[i + 1], 4, -1530992060);
            d = hh(d, a, b, c, x[i + 4], 11, 1272893353);
            c = hh(c, d, a, b, x[i + 7], 16, -155497632);
            b = hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = hh(a, b, c, d, x[i + 13], 4, 681279174);
            d = hh(d, a, b, c, x[i + 0], 11, -358537222);
            c = hh(c, d, a, b, x[i + 3], 16, -722521979);
            b = hh(b, c, d, a, x[i + 6], 23, 76029189);
            a = hh(a, b, c, d, x[i + 9], 4, -640364487);
            d = hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = hh(c, d, a, b, x[i + 15], 16, 530742520);
            b = hh(b, c, d, a, x[i + 2], 23, -995338651);

            a = ii(a, b, c, d, x[i + 0], 6, -198630844);
            d = ii(d, a, b, c, x[i + 7], 10, 1126891415);
            c = ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = ii(b, c, d, a, x[i + 5], 21, -57434055);
            a = ii(a, b, c, d, x[i + 12], 6, 1700485571);
            d = ii(d, a, b, c, x[i + 3], 10, -1894986606);
            c = ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = ii(b, c, d, a, x[i + 1], 21, -2054922799);
            a = ii(a, b, c, d, x[i + 8], 6, 1873313359);
            d = ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = ii(c, d, a, b, x[i + 6], 15, -1560198380);
            b = ii(b, c, d, a, x[i + 13], 21, 1309151649);
            a = ii(a, b, c, d, x[i + 4], 6, -145523070);
            d = ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = ii(c, d, a, b, x[i + 2], 15, 718787259);
            b = ii(b, c, d, a, x[i + 9], 21, -343485551);

            a = add(a, olda);
            b = add(b, oldb);
            c = add(c, oldc);
            d = add(d, oldd);
        }
        return rhex(a) + rhex(b) + rhex(c) + rhex(d);
    };

    return MD5(value);
};





/* harmony default export */ __webpack_exports__["a"] = (new Apm({ cookies: __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a, fetchJsonp: __WEBPACK_IMPORTED_MODULE_5_fetch_jsonp___default.a, axios: __WEBPACK_IMPORTED_MODULE_6_axios___default.a }));

/***/ }),

/***/ 771:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 782:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

module.exports = "../../static/img/banner2.jpg?c3144d7";

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(782)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(840),
  /* scopeId */
  "data-v-6e114275",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 829:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "top-wrap"
  }, [_c('div', {
    staticClass: "center-wrap"
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_c('a', {
    staticClass: "logo-wrap",
    attrs: {
      "href": _vm.winPageData.index_page
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "//zkres.myzaker.com/static/rmt/logo.png",
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-list"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;",
      "title": "合作方式"
    }
  }, [_vm._v("合作方式")]), _vm._v(" "), (_vm.winPageData.user_info) ? _c('a', {
    staticClass: "user",
    attrs: {
      "href": _vm.winPageData.myorg_page
    }
  }, [_vm._v("进入后台")]) : _c('a', {
    attrs: {
      "href": _vm.winPageData.login_page,
      "title": "登录"
    }
  }, [_vm._v("登录")])])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "block-wrap block-1"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "block-line"
  }, [_c('div', {
    staticClass: "inner-block"
  }, [_c('h2', {
    staticClass: "block-1-title"
  }, [_vm._v("核心产品")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.b1),
      expression: "picPath.b1",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-1-subtitle"
  }, [_vm._v("云服务超市，可自主挑选、搭配产品和服务")]), _vm._v(" "), _c('p', {
    staticClass: "block-1-content"
  }, [_vm._v("\n              从舆情监测、指挥调度，到全媒体内容生产、审核、分发、统计、考核、版权管理，再到经营服务、平台建设、可视化等，进行集约建设、模块化输出，并有专门团队进行定期升级、运维支持和长期培训服务。")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-block"
  }, [_c('h2', {
    staticClass: "block-1-title"
  }, [_vm._v("行业地位")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.b2),
      expression: "picPath.b2",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-1-subtitle"
  }, [_vm._v("国内媒体融合第三条路径的创造者")]), _vm._v(" "), _c('p', {
    staticClass: "block-1-content"
  }, [_vm._v("\n              在“内容、渠道、平台、经营、管理”全领域与主流媒体深度融合，用跨区域、跨介质、跨产业的融合发展，为传媒产业的转型升级打开了想象空间。")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-line"
  }, [_c('div', {
    staticClass: "inner-block"
  }, [_c('h2', {
    staticClass: "block-1-title"
  }, [_vm._v("合作优势")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.b3),
      expression: "picPath.b3",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-1-subtitle"
  }, [_vm._v("‌‌资深团队深耕国内领先资讯平台ZAKER近九年\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "block-1-content"
  }, [_vm._v("\n              出色的开发团队、前沿的核心技术，更理解媒体行业、更了解媒体运营，对新闻行业、媒体融合具备更长远的规划和运营支撑。")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-block"
  }, [_c('h2', {
    staticClass: "block-1-title"
  }, [_vm._v("主要伙伴")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.b4),
      expression: "picPath.b4",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-1-subtitle"
  }, [_vm._v("已与各省市主流媒体合作4年")]), _vm._v(" "), _c('p', {
    staticClass: "block-1-content"
  }, [_vm._v("\n              已与“现代快报、潇湘晨报、新快报、新文化报、兰州日报、贵阳日报、南宁日报、辽沈晚报、新晚报、合肥晚报”等近30家主流媒体进行了合作。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap live",
    attrs: {
      "data-sec": "0",
      "data-third": "0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.live_icon),
      expression: "picPath.live_icon",
      arg: "background-image"
    }],
    staticClass: "icon lazy"
  })]), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("直播套件")]), _vm._v(" "), _c('h3', {
    staticClass: "block-subtitle"
  }, [_vm._v("权威、轻量化移动PGC直播生产管理平台")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.live),
      expression: "picPath.live",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("\n              多种终端、多机位超强映像表现能力：完美支持手机、无人机、摄像机、监控设备、VR摄像机等各种摄像设备，及推拉流适配。\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.live5),
      expression: "picPath.live5",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("直播管理平台")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("\n              高直播用户观看体验：重要信息以文字、图片（静态/Gif）等形式进行补充，背景音乐添加、预告片预热、用户评论互动和管理等；\n              二次传播效果优化：回看下载剪辑，直播数据统计分析。\n            ")])])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("了解详情")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击链接查看更多内容")]), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c1),
      expression: "picPath.c1",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("贵阳晚报《伙食团》1期/周")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("以贵阳市、贵州省范围的餐饮题材内容为主要对象，推荐美食，分享美味，聚集吃货。")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c2),
      expression: "picPath.c2",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("合肥晚报《萌娃学堂》1期/周")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("一档集幽默、生活、寓教于乐三位一体的亲子节目，旨在通过孩子和主持人的互动协作，展现当代年轻父母和孩子们的交流方式。")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap hsm",
    attrs: {
      "data-sec": "0",
      "data-third": "1"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.hsm_icon),
      expression: "picPath.hsm_icon",
      arg: "background-image"
    }],
    staticClass: "icon-box icon lazy"
  }), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("红树莓")]), _vm._v(" "), _c('h3', {
    staticClass: "block-subtitle"
  }, [_vm._v("更安全、高效的移动短视频采编审发工具")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.hsm),
      expression: "picPath.hsm",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("免费使用")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击获取下载方式和相关文档")]), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c3),
      expression: "picPath.c3",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("贵阳晚报《Z视频》记录型视频")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c4),
      expression: "picPath.c4",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("新晚报《冰城5分熟》记录型视频")]), _vm._v(" "), _vm._m(6)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap ai",
    attrs: {
      "data-sec": "0",
      "data-third": "2"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.ai_icon),
      expression: "picPath.ai_icon",
      arg: "background-image"
    }],
    staticClass: "icon-box icon lazy"
  }), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("AI语音合成")]), _vm._v(" "), _c('h3', {
    staticClass: "block-subtitle bold"
  }, [_vm._v("\n          国内首家专注应用前沿人工智能语音合成技术于内容报道形态创新的平台。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.ai),
      expression: "picPath.ai",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("了解详情")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击链接查看更多内容")]), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c5),
      expression: "picPath.c5",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("新快报《新新播报》1期/天")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("以智能语音播报前天及当天广东地区的重要新闻。")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c6),
      expression: "picPath.c6",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("现代快报《知了新闻》1期/天")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("一档日常早间新闻播报类栏目。")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap vr",
    attrs: {
      "data-sec": "0",
      "data-third": "3"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.vr_icon),
      expression: "picPath.vr_icon",
      arg: "background-image"
    }],
    staticClass: "icon-box icon lazy"
  }), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("威芽")]), _vm._v(" "), _c('h3', {
    staticClass: "block-subtitle"
  }, [_vm._v("\n          “带你进入新闻现场”的沉浸式VR全景新闻生产工具\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.vr),
      expression: "picPath.vr",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('h2', {
    staticClass: "block-title sm"
  }, [_vm._v("全景+新闻")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          把实地场景转化为可视化内容，把新闻第一现场立体化呈现，增强用户与新闻现场联结。从“看新闻”到“带你进入新闻现场”，给用户更直观、动态的理解。适用于大会报道、演唱会、体育赛事、突发现场、景区导览等等场景。 ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("免费使用")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击获取下载方式和相关文档")]), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c7),
      expression: "picPath.c7",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("现代快报")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("《VR全景 | 江苏省政协十二届一次会议开幕》")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c8),
      expression: "picPath.c8",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("今日消费")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("《全景VR+视频看房大集合》")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap h5",
    attrs: {
      "data-sec": "0",
      "data-third": "4"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.h5_icon),
      expression: "picPath.h5_icon",
      arg: "background-image"
    }],
    staticClass: "icon-box icon lazy"
  }), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("H5平台")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.h5),
      expression: "picPath.h5",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c9),
      expression: "picPath.c9",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("演示")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c10),
      expression: "picPath.c10",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("抽奖")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c11),
      expression: "picPath.c11",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("问卷、测试")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c12),
      expression: "picPath.c12",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("投票")])]), _vm._v(" "), _c('div', {
    staticClass: "coop-block"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c13),
      expression: "picPath.c13",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("表单")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap design",
    attrs: {
      "data-sec": "0",
      "data-third": "5"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.design_icon),
      expression: "picPath.design_icon",
      arg: "background-image"
    }],
    staticClass: "icon-box icon lazy"
  }), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v("云设计")]), _vm._v(" "), _c('h3', {
    staticClass: "block-subtitle"
  }, [_vm._v("前沿视觉效果的轻量化美编工具")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.design),
      expression: "picPath.design",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("了解详情")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击链接查看更多内容")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab12",
    attrs: {
      "data-sec": "1"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("全媒体指挥调度平台")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          集“媒资管理、策采编发审、指挥调度”于一体，PC端与移动端配合的平台。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab12),
      expression: "picPath.tab12",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab2",
    attrs: {
      "data-sec": "2"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("内容安全三审系统")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          共享ZAKER现有的安全防控体系，包括敏感内容智能识别预警、评论管理系统、反黑客攻击、账号管理系统等，通过移动端实现实时提交、实时审核，高效便捷。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.nrss),
      expression: "picPath.nrss",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab6",
    attrs: {
      "data-sec": "3"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("全媒体舆情监控系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab61),
      expression: "picPath.tab61",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("全网信息监测")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("采集监测“网站、微信、微博、客户端、纸媒”等全网信息")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab62),
      expression: "picPath.tab62",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("热点发现")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("分析全网热点和舆论发展趋势，掌握地方重点事件，预测、发现热点走势，为内容生产提供指导。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab65),
      expression: "picPath.tab65",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("舆情预警")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("实时舆情预警，后台、电话、短信警报")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab63),
      expression: "picPath.tab63",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("舆情报告")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("舆情日报，月报，季度报，年报")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab64),
      expression: "picPath.tab64",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("事件回溯")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("事件（领导、专题、政情等）定向监测，回溯分析报告")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab66),
      expression: "picPath.tab66",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("方案设置")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("针对特定“事件”自主设置舆情预警及监测方案，实时预测热点、舆情事件发生的可能性")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab4",
    attrs: {
      "data-sec": "4"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("内容管理平台")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab4),
      expression: "picPath.tab4",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab5",
    attrs: {
      "data-sec": "5"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("用户管理系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab51),
      expression: "picPath.tab51",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("用户分级管理")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("按照用户活跃度、贡献度将用户进行划分，重点做好核心用户高价值用户的关系维护。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab52),
      expression: "picPath.tab52",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("用户安全管理")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("对用户平台账号、昵称、头像、评论、发帖、扰乱平台秩序等进行管理。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab53),
      expression: "picPath.tab53",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("用户行为统计")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("建立数据模型，分析用户行为，即阅读习惯及喜好，提升媒体社会影响力。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab3",
    attrs: {
      "data-sec": "6"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("融合发布系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab31),
      expression: "picPath.tab31",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("系统对接")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("系统接口对接，包含不限于：APP、双微、网站、新旧系统等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab32),
      expression: "picPath.tab32",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("一键分发")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("实现一体策划、一次采集、多种生成、一键分发，多元传播的建设理念。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab15",
    attrs: {
      "data-sec": "7"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("可视化呈现")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab15),
      expression: "picPath.tab15",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          支持多种业务数据信息的可视化呈现，包括互联网汇聚数据、报题或选题数据、生产或发布的内容数据、新闻生产流程状态数据、指挥调度信息、新闻传播影响力结果等。\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab13",
    attrs: {
      "data-sec": "8"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("绩效统计系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab131),
      expression: "picPath.tab131",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("多维考核")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("支持结合具体的绩效管理统计办法进行绩效考核统计设定，如：发稿数、转发数、评论数、观看量、价值性、影响力等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab132),
      expression: "picPath.tab132",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("数据导出")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("可以按人员、按时段、按类型等分类一键导出。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab10",
    attrs: {
      "data-sec": "9"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("广告投放系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-line"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab102),
      expression: "picPath.tab102",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("排期系统")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("对计划投放、已投放的广告进行点位、排期管理。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab103),
      expression: "picPath.tab103",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("广告类型")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("支持CPD、CPC、CPM、创意广告、内容定制型广告产品样式等。")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-line"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab101),
      expression: "picPath.tab101",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("广告上线")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("对广告素材进行内测、预览、上线操作。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab104),
      expression: "picPath.tab104",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("数据统计")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("含广告曝光、点击数据查看。")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab11",
    attrs: {
      "data-sec": "10"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("营销服务平台")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab111),
      expression: "picPath.tab111",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("案例共享")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("平台月度、季度、年度项目规划及联动征集。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab113),
      expression: "picPath.tab113",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("专家智库")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("构建各行业专家智库，输出行业报告，专业辅助决策。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab112),
      expression: "picPath.tab112",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("策略支持")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("从每个节点的招商方案输出、个案辅助制作，到跨城市商业案例复制再造；从各类营销玩法教授，到运用数据做结案分析。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab114),
      expression: "picPath.tab114",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("传播资源")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("综合线上线下全网覆盖、跨媒体跨城市联动传播，从渠道资源到创意广告、到内容产品，合作超越资源本身。")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-coop"
  }, [_c('h2', {
    staticClass: "coop-title"
  }, [_vm._v("合作案例")]), _vm._v(" "), _c('div', {
    staticClass: "coop-content"
  }, [_c('div', {
    staticClass: "coop-block one"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.c14),
      expression: "picPath.c14",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _vm._m(15)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab9",
    attrs: {
      "data-sec": "11"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("政务号服务")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab9),
      expression: "picPath.tab9",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          为政府部门提供政务号运营，推进政务公开、优化政务服务、凝聚社会共识、创新社会治理。\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab7",
    attrs: {
      "data-sec": "12"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("APP搭建")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab7),
      expression: "picPath.tab7",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab8",
    attrs: {
      "data-sec": "13"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("小程序开发")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab81),
      expression: "picPath.tab81",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("Saas平台")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("集成多个功能模板，快速生成如垂直资讯、政务发布、民生服务等不同业务场景小程序。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab82),
      expression: "picPath.tab82",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("小程序")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("以微信的社交场景为依托，打造如“权威养生图文资讯”、“经济民生语音播报”等多形态、易传播的社交资讯阵地。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-wrap tab14",
    attrs: {
      "data-sec": "14"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "block-title lg"
  }, [_vm._v("内容共享及版权管理系统")]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab141),
      expression: "picPath.tab141",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("版权代理")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("支持原创认定，为授权的版权方提供线上线下版权交易、内容共享代理等服务。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab142),
      expression: "picPath.tab142",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("维权服务")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("用非诉、诉讼手段帮助媒体提升版权品牌价值，提高媒体版权变现收益。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab143),
      expression: "picPath.tab143",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("网页存证")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("与公证处合作的原创电子公证服务，存证“实时高效，公正、权威、价格便宜”。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab144),
      expression: "picPath.tab144",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("转载分析")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("提供原创稿件全网的实时传播路径，稿件转载明细，媒体转载详情。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab145),
      expression: "picPath.tab145",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("侵权预警")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("及时报告乙方侵权行为，并规避自身“非法”转载。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab146),
      expression: "picPath.tab146",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("律师联盟")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("提供专业律师属地化服务，提供跨区域媒体版权服务支持。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.tab147),
      expression: "picPath.tab147",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  }), _vm._v(" "), _c('h3', {
    staticClass: "block-content-column-title"
  }, [_vm._v("在线交易")]), _vm._v(" "), _c('p', {
    staticClass: "block-content-column-desc"
  }, [_vm._v("线上图片、视频素材上传到平台审核通过后，综合定价，在线交易管理。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content-column"
  })])])]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "block-wrap cooper-media"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "cooper-title"
  }, [_vm._v("合作媒体")]), _vm._v(" "), _c('h3', {
    staticClass: "cooper-subtitle"
  }, [_vm._v("融媒体合作伙伴")]), _vm._v(" "), _c('div', {
    staticClass: "cooper-content clearfix"
  }, [_c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://wb.sznews.com/PC/layout/201908/27/node_A01.html",
      "title": "深圳晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            深圳晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic1),
      expression: "picPath.cooper.pic1",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.jnds.com.cn/",
      "title": "江南都市报",
      "target": "_blank"
    }
  }, [_vm._v("\n            江南都市报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic2),
      expression: "picPath.cooper.pic2",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "https://www.dahe.cn/",
      "title": "今日消费",
      "target": "_blank"
    }
  }, [_vm._v("\n            今日消费\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic3),
      expression: "picPath.cooper.pic3",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://xdkb.net/",
      "title": "现代快报",
      "target": "_blank"
    }
  }, [_vm._v("\n            现代快报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic4),
      expression: "picPath.cooper.pic4",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.nnnews.net/",
      "title": "南宁晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            南宁晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic5),
      expression: "picPath.cooper.pic5",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.xkb.com.cn/",
      "title": "新快报",
      "target": "_blank"
    }
  }, [_vm._v("\n            新快报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic6),
      expression: "picPath.cooper.pic6",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.hf365.com/",
      "title": "合肥晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            合肥晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic7),
      expression: "picPath.cooper.pic7",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.lnd.com.cn/",
      "title": "辽沈晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            辽沈晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic8),
      expression: "picPath.cooper.pic8",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://epaper.heyuan.cn/html/2019-08/27/node_1.htm",
      "title": "河源日报",
      "target": "_blank"
    }
  }, [_vm._v("\n            河源日报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic9),
      expression: "picPath.cooper.pic9",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.gywb.cn/",
      "title": "贵阳晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            贵阳晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic10),
      expression: "picPath.cooper.pic10",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.sjzdaily.com.cn/",
      "title": "燕赵晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            燕赵晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic11),
      expression: "picPath.cooper.pic11",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.sunnews.cn/",
      "title": "海西晨报",
      "target": "_blank"
    }
  }, [_vm._v("\n            海西晨报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic12),
      expression: "picPath.cooper.pic12",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.hilizi.com/",
      "title": "半岛晨报",
      "target": "_blank"
    }
  }, [_vm._v("\n            半岛晨报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic13),
      expression: "picPath.cooper.pic13",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.qhdnews.com/",
      "title": "秦皇岛日报",
      "target": "_blank"
    }
  }, [_vm._v("\n            秦皇岛日报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic14),
      expression: "picPath.cooper.pic14",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.lzbs.com.cn/",
      "title": "兰州日报",
      "target": "_blank"
    }
  }, [_vm._v("\n            兰州日报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic15),
      expression: "picPath.cooper.pic15",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.my399.com/",
      "title": "新晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            新晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic16),
      expression: "picPath.cooper.pic16",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.bdall.com/",
      "title": "保定晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            保定晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic17),
      expression: "picPath.cooper.pic17",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.xxcb.cn/",
      "title": "潇湘晨报",
      "target": "_blank"
    }
  }, [_vm._v("\n            潇湘晨报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic18),
      expression: "picPath.cooper.pic18",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.taiandaily.com.cn/",
      "title": "泰安日报",
      "target": "_blank"
    }
  }, [_vm._v("\n            泰安日报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic19),
      expression: "picPath.cooper.pic19",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "#",
      "title": "",
      "target": "_blank"
    }
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic20),
      expression: "picPath.cooper.pic20",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "#",
      "title": "",
      "target": "_blank"
    }
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic21),
      expression: "picPath.cooper.pic21",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.xwh.cn/",
      "title": "新文化报",
      "target": "_blank"
    }
  }, [_vm._v("\n            新文化报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic22),
      expression: "picPath.cooper.pic22",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "#",
      "title": "",
      "target": "_blank"
    }
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic23),
      expression: "picPath.cooper.pic23",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })]), _vm._v(" "), _c('a', {
    staticClass: "cooper-link",
    attrs: {
      "href": "http://www.ycwb.com/",
      "title": "羊城晚报",
      "target": "_blank"
    }
  }, [_vm._v("\n            羊城晚报\n            "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.picPath.cooper.pic24),
      expression: "picPath.cooper.pic24",
      arg: "background-image"
    }],
    staticClass: "pic lazy"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_footer",
    attrs: {
      "id": "wrap_footer"
    }
  }, [_c('div', {
    attrs: {
      "id": "footer_inner"
    }
  }, [_c('span', [_vm._v("Copyright © 2011-2019 ZAKER.All Rights Reserved")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer1"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.miibeian.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备12019658号-1")]), _vm._v("  "), _c('font', {
    attrs: {
      "color": "#ff5050\n    "
    }
  }, [_vm._v("/")]), _vm._v("  "), _c('a', {
    attrs: {
      "href": "//www.myzaker.com/images/new/bottom/XKZ1.jpg",
      "target": "_blank"
    }
  }, [_vm._v("ICP证粤B2-20130159")]), _vm._v("  "), _c('font', {
    attrs: {
      "color": "#ff5050\n    "
    }
  }, [_vm._v("/")]), _vm._v("  网络出版服务许可证："), _c('a', {
    attrs: {
      "href": "//www.myzaker.com/images/new/bottom/XKZ3.jpg",
      "target": "_blank"
    }
  }, [_vm._v("（总）网出证（粤）字第050号")]), _vm._v("  "), _c('font', {
    attrs: {
      "color": "#ff5050\n    "
    }
  }, [_vm._v("/")]), _vm._v("  "), _c('a', {
    attrs: {
      "href": "//www.myzaker.com/images/new/bottom/XKZ2_.jpg",
      "target": "_blank"
    }
  }, [_vm._v("增值电信业务经营许可证B2-20150871")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer3"
    }
  }), _vm._v("\n      网络文化经营许可证："), _c('a', {
    attrs: {
      "href": "//www.myzaker.com/images/new/bottom/XKZ1.jpg",
      "target": "_blank"
    }
  }, [_vm._v("粤网文[2018]6864-2439号")]), _vm._v("  "), _c('font', {
    attrs: {
      "color": "#ff5050\n    "
    }
  }, [_vm._v("/")]), _vm._v("  法律邮箱：law@myzaker.com  "), _c('font', {
    attrs: {
      "color": "#ff5050"
    }
  }, [_vm._v("/")]), _vm._v("  "), _vm._m(18), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer4"
    }
  }), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20)], 1)]), _vm._v(" "), _c('r-login')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed-nav-wrap",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "fixed-nav-bar"
  }, [_c('div', {
    staticClass: "fixed-nav"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav-wrap"
  }, [_c('div', {
    staticClass: "sub-nav-list"
  }, [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "javascript:;",
      "data-cls": "live"
    }
  }, [_vm._v("直播套件")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-cls": "hsm"
    }
  }, [_vm._v("红树莓 - 短视频")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-cls": "ai"
    }
  }, [_vm._v("AI 语音合成")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-cls": "vr"
    }
  }, [_vm._v("VR 全景")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-cls": "h5"
    }
  }, [_vm._v("H5 平台")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-cls": "design"
    }
  }, [_vm._v("云设计")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-list"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("全媒体生产工具")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("指挥调度")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("安全审核")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("舆情监控")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("内容管理")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("融合发布")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("可视化")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("绩效统计")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("广告投放")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("营销平台")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("政务服务")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("App搭建")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("小程序开发")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("版权管理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-wrap"
  }, [_c('div', {
    staticClass: "banner-inner"
  }, [_c('h2', {
    staticClass: "banner-title"
  }, [_vm._v("媒体融合业务的云服务超市")]), _vm._v(" "), _c('h3', {
    staticClass: "banner-subtitle"
  }, [_vm._v("深耕媒体融合实践4年，整合搭建新型媒体业务平台，"), _c('br'), _vm._v("6套生产工具、7大融媒体系统、3大生产管理平台、2个发布端口、1套政务服务体系，"), _c('br'), _vm._v("为媒体融合全领域赋能增效。")]), _vm._v(" "), _c('img', {
    staticClass: "banner lazy",
    attrs: {
      "src": "//zkres.myzaker.com/static/rmt/banner.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "block-title block-content-column-title"
  }, [_vm._v("LIVE直播现场"), _c('span', {
    staticClass: "cha"
  }), _vm._v("导播")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-colunm-desc-wrap"
  }, [_c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("移动采编")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("具备远程回传、素材快速剪辑、图片合成视频、智能语音适配、人脸识别马赛克、背景音乐穿插等移动生产功能。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("三审机制")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("随时随地响应“内容批复”，方便快捷的流程实现移动指挥调度。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("多平台分发")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("通过采编后台发布至目标渠道，如自身新闻APP，或者绑定的第三方平台：腾讯 、优酷 、双微等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("溶洞篮球场、百年戴公馆、挥拳吧小汤圆"), _c('br'), _vm._v("已发布3期。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("记录冰城人民风情、城市面貌"), _c('br'), _vm._v("已发布10期。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-colunm-desc-wrap"
  }, [_c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("多语言多音色")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("提供基础男声、女声发音，支持变调，中文、英文、中英文混读合成，支持背景音乐添加，陆续推出更多特色发音功能。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("方便快捷的集成方式")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("简单易操作，节省融媒体人力，引领行业尖端技术潮流，探索全新的内容报道形式。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("丰富的场景应用")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("特色人工智能语音播报，可运用在媒体的日常业务中，满足用户在不同场景下获取资讯的需求。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "block-subtitle"
  }, [_vm._v("\n          用户运营、商业互动场景下的H5制作工具"), _c('br'), _vm._v(" 含“表单、投票、测验、问卷、演示、抽奖”，满足县级融媒体日常运营需求。\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "block-h5-table"
  }, [_c('tr', [_c('td', [_vm._v("表单")]), _vm._v(" "), _c('td', [_vm._v("用户报名、信息收集等功能。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("报名+投票")]), _vm._v(" "), _c('td', [_vm._v("用在投票评选类活动的开展。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("问卷、测验")]), _vm._v(" "), _c('td', [_vm._v("可用在趣味问答、问答比赛、创意用户互动策划等。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("抽奖")]), _vm._v(" "), _c('td', [_vm._v("包括大转盘、刮刮乐、老虎机等趣味互动形式，可以配合拉新活动使用，通过抽奖刺激用户参与活动、下载客户端。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-box"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("了解详情")]), _vm._v(" "), _c('a', {
    staticClass: "block-remark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("点击链接查看更多内容")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          可以通过此后台有效地进行图片编辑工作，云后台功能包括上传各种图片素材"), _c('br'), _vm._v("\n          和数据图表、输入文字、选择模板、设置背景样式等。\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-colunm-desc-wrap"
  }, [_c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("远程回传模块")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("支持移动终端设备采集的文字、图片、音频、视频内容等各类型文件远程回传和回传文件管理等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("素材管理")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("支持文字、图片、音频、视频等不同类型外采资源的采集或导入，部门素材库浏览、挑选等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("选题提交-审核流程")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("选题创建和编辑、选题筛选、选题审核派发、组合报道等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("指挥调度")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("任务创建、指派、确认、状态查询、即时通讯等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-colunm-desc-wrap"
  }, [_c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("报提审核")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("支持选题移动审核、派发。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("发布审核")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("发布渠道的发布前、发布后内容进行三级审核流程。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("安全防控")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("包括敏感内容人工智能识别预警、评论分级管理系统、反黑客攻击、审核人员工作日志、统计报表等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-colunm-desc-wrap"
  }, [_c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("内容管理")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("全媒体数字资料的存储管理、检索及再利用，包括资源“入库、管理、检索、展现、出库、分级存储”等。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("内容编辑")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("支持新闻稿件的多级审核、编辑、选用、推送、分享等功能。")])]), _vm._v(" "), _c('div', {
    staticClass: "block-colunm-desc"
  }, [_c('h4', {
    staticClass: "block-colunm-desc-title"
  }, [_vm._v("数据分析")]), _vm._v(" "), _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("支持对用户点击、转发、评论等数据的采集，频道发稿情况的统计，编辑/记者发稿情况的统计。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('h3', {
    staticClass: "coop-block-title"
  }, [_vm._v("新晚报")]), _vm._v(" "), _c('p', {
    staticClass: "coop-block-content"
  }, [_vm._v("\n                  2018年ZAKER哈尔滨旅发委全案营销。借助线上线下、跨城市传播，项目总曝光量达9400余万。其中："), _c('br'), _vm._v("\n                  ·《行行摄摄大美冰城》更是成为推介旅游、营销城市的经典案例；"), _c('br'), _vm._v("\n                  ·《旅发大会》，霸屏式宣传报道，向全国范围更多的目标潜在客户展示了强大的内容生产能力、技术运用能力、全媒体推广能力。\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "block-desc"
  }, [_vm._v("\n          具备内容聚合自媒体/政务号订阅体系、兴趣推荐算法、视听（直播、点播）体系、生活服务板块体系、个人主页用户管理体系。"), _c('br'), _vm._v("\n          支持文、图、视频、直播、VR、H5等内容发布。\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-wrap cooper-type"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "cooper-title"
  }, [_vm._v("合作方式")]), _vm._v(" "), _c('h3', {
    staticClass: "cooper-subtitle"
  }, [_vm._v("全媒体内容生产工具，开通账号即可使用，一站式服务、一秒上手、快速发布，"), _c('br'), _vm._v("轻便灵活，成本更低。")]), _vm._v(" "), _c('div', {
    staticClass: "cooper-content"
  }, [_c('div', {
    staticClass: "cooper-block"
  }, [_c('div', {
    staticClass: "cooper-block-title"
  }, [_vm._v("体验版")]), _vm._v(" "), _c('p', {
    staticClass: "cooper-block-text"
  }, [_vm._v("\n              申请一个测试账号，一键登录体验系列产品。\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "cooper-block"
  }, [_c('div', {
    staticClass: "cooper-block-title"
  }, [_vm._v("专业版")]), _vm._v(" "), _c('p', {
    staticClass: "cooper-block-text"
  }, [_vm._v("\n              服务包含但不限于：云服务、账号体系、数据管理等。更多融媒体产品、服务解决方案，可沟通定制\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cooper-bottom"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("更多项目合作 商务咨询")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("020-38488576 / 13570964521 "), _c('br'), _vm._v("\n            lifenni@myzaker.com\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602001315"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin": "0 5px 0 0"
    },
    attrs: {
      "src": "//www.myzaker.com/images/new/bottom/ga.png"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline",
      "color": "#939393"
    }
  }, [_vm._v("粤公网安备 44010602001315号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.gzaic.gov.cn/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "bottomimg",
    attrs: {
      "src": "//www.myzaker.com/images/new/bottom/1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.gzjd.gov.cn/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "bottomimg",
    attrs: {
      "src": "//www.myzaker.com/images/new/bottom/2.png"
    }
  })])
}]}

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('a', {
    staticClass: "close-btn",
    attrs: {
      "href": "javascript:;"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    attrs: {
      "type": "password",
      "placeholder": "密码"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn"
  }, [_vm._v("登录")])])])
}]}

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return scrollToEle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queryStringify; });
/* unused harmony export parseQuery */
/* unused harmony export setHost */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRandomColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_plugin_apm_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





function animationEase(start, end, rate, callback) {

  if (start == end || typeof start != 'number') {
    return;
  }
  end = end || 0;
  rate = rate || 2;

  var step = function step() {
    start = start + (end - start) / rate;

    if (Math.abs(end - start) < 1) {
      callback(end, true);
      return;
    }
    callback(start, false);
    requestAnimationFrame(step);
  };
  step();
}

var scrollToEle = function scrollToEle(_ref) {
  var wrapEl = _ref.wrapEl,
      el = _ref.el,
      startPosY = _ref.startPosY,
      _ref$scrollRate = _ref.scrollRate,
      scrollRate = _ref$scrollRate === undefined ? 5 : _ref$scrollRate,
      finish = _ref.finish;

  if (!el) return;
  var doc = wrapEl ? wrapEl : document.body.scrollTop ? document.body : document.documentElement;
  var top = typeof el == 'number' ? el : el.offsetTop;
  var _scrollTop = startPosY != undefined ? startPosY : doc.scrollTop;
  animationEase(_scrollTop, top, scrollRate, function (value, isEnd) {
    doc.scrollTop = value;

    if (isEnd) {
      finish && finish();
    }
  });
};

var queryStringify = function queryStringify(obj) {
  var isEncode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var query = '';
  for (var o in obj) {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[0]) == 'object') {
      query += '&' + queryStringify(obj[o]);
    } else {
      if (isEncode) {
        query += '&' + o + '=' + encodeURI(encodeURI(obj[o]));
      } else {
        query += '&' + o + '=' + obj[o];
      }
    }
  }
  return query;
};

var parseQuery = function parseQuery(query) {
  var reg = /([^=&\s]+)[=\s]*([^&\s]*)/g;
  var obj = {};
  while (reg.exec(query)) {
    obj[RegExp.$1] = RegExp.$2;
  }
  return obj;
};

var setHost = function setHost(api) {
  if (location.host !== '121.9.213.58') {
    api = api.replace('121.9.213.58/', '');
  }

  if (window.location.host.indexOf('localhost') !== -1) {
    return api.replace('https://', 'http://121.9.213.58/');
  }
  if (window.location.host === '121.9.213.58') {
    return api.replace('https://', 'http://121.9.213.58/');
  } else {
    return api.replace('https://', window.location.protocol + '//');
  }
};

var formatDate = function formatDate(date, fmt) {
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'S': date.getMilliseconds() };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  };
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  };
  return fmt;
};

var getRandomColor = function getRandomColor(index) {
  var array = ["#2ec7c9", "#b6a2de", "#5ab1ef", "#ffb980", "#d87a80", "#8d98b3", "#e5cf0d", "#97b552", "#95706d", "#dc69aa", "#07a2a4", "#9a7fd1", "#588dd5", "#f5994e", "#c05050", "#59678c", "#c9ab00", "#7eb00a", "#6f5553", "#c14089"];
  var cur = Math.round(Math.random() * (array.length - 1));
  if (index !== undefined && index <= array.length - 1) {
    cur = index;
  }
  var value = array[cur];
  return value;
};



/***/ })

},[392]);


// WEBPACK FOOTER //
// static/js?bc076a258a790184ac18